// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__1om25"};